import { c as _c } from "react/compiler-runtime";
import AuctionPriceTable from "@/components/atoms/AuctionPriceTable";
import CardAvatar from "@/components/cardElements/CardAvatar";
import { Card, CardContent } from "@/components/ui/card";
import { BusinessType, RealEstateType } from "@/types/real-estate";
import { Clock } from "lucide-react";
import AuctionTimer from "../../../../pages/search/AuctionTimer";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import RenderImage from "@/components/atoms/RenderImage";
import { useRealEstateAgencyCard } from "./useRealEstateAgencyCard";
import { useIsMobile } from "@/hooks/use-mobile";
import { RealEstateAgencyCardRoomRent } from "./RealEstateAgencyCardRoomRent";
import { AgencyContactRows } from "./AgencyContactRows";
type Props = {
  realEstateData: RealEstateType;
  realEstateId: string;
  title: string;
};
export default function RealEstateAgencyCard(t0) {
  const $ = _c(44);
  const {
    realEstateData,
    realEstateId,
    title
  } = t0;
  let t1;
  if ($[0] !== realEstateData || $[1] !== realEstateId) {
    t1 = {
      realEstateData,
      realEstateId
    };
    $[0] = realEstateData;
    $[1] = realEstateId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    handleCopy,
    agency,
    realEstate,
    features,
    phones,
    agents,
    url,
    user,
    hasContacts,
    isOwner,
    handleSendMessage,
    t
  } = useRealEstateAgencyCard(t1);
  const isMobile = useIsMobile();
  let t2;
  if ($[3] !== agency?.email || $[4] !== agency?.logo || $[5] !== agency?.name || $[6] !== agents || $[7] !== handleCopy || $[8] !== handleSendMessage || $[9] !== isOwner || $[10] !== phones || $[11] !== t || $[12] !== title || $[13] !== url || $[14] !== user) {
    t2 = () => {
      const header = user ? <div className="w-14 h-14 rounded-full overflow-hidden border border-border shadow-md shrink-0"><RenderImage src={user?.image} alt={user?.name} className="object-cover scale-150" /></div> : <div className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-border bg-card p-1.5 shadow-md"><RenderImage src={agency?.logo} alt={agency?.name ?? ""} className="object-contain" /></div>;
      return <CardContent className="flex flex-col gap-3 p-5" data-sentry-element="CardContent" data-sentry-component="renderSaleContent" data-sentry-source-file="RealEstateAgencyCard.tsx"><div className="flex items-center gap-4 min-w-0">{header}<div className="flex flex-col min-w-0 flex-1 gap-0.5"><span className="font-semibold text-base text-foreground-heading truncate">{user ? user.name : agency?.name}</span>{!user && agents?.length > 0 && <span className="text-xs text-faint-foreground truncate">{agents.map(_temp).join(", ")}</span>}</div>{!user && agents?.length > 0 && <div className="flex items-center -space-x-3 shrink-0">{agents.map(_temp2)}</div>}{user && !isOwner && <Button variant="simpleDark" size="md" onClick={handleSendMessage} className="self-center shrink-0 rounded-full px-5">{t("sendMessage")}</Button>}</div>{!user && (phones?.length || agency?.email) && <><Separator /><AgencyContactRows phones={phones} email={agency?.email} title={title} url={url} handleCopy={handleCopy} /></>}</CardContent>;
    };
    $[3] = agency?.email;
    $[4] = agency?.logo;
    $[5] = agency?.name;
    $[6] = agents;
    $[7] = handleCopy;
    $[8] = handleSendMessage;
    $[9] = isOwner;
    $[10] = phones;
    $[11] = t;
    $[12] = title;
    $[13] = url;
    $[14] = user;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const renderSaleContent = t2;
  let t3;
  if ($[16] !== features || $[17] !== realEstate.businessType || $[18] !== realEstate.lastBidPrice || $[19] !== realEstate.logoSquared || $[20] !== realEstate.minPrice || $[21] !== realEstate.openingPrice || $[22] !== realEstate.propertyUrl || $[23] !== realEstate.salePrice || $[24] !== t) {
    t3 = () => <CardContent data-sentry-element="CardContent" data-sentry-component="renderAuctionContent" data-sentry-source-file="RealEstateAgencyCard.tsx"><div className="items-start flex flex-col gap-3 justify-between w-full mb-4"><div className="flex gap-2"><div className="h-12 w-12 rounded-full"><CardAvatar imgUrl={realEstate?.logoSquared} data-sentry-element="CardAvatar" data-sentry-source-file="RealEstateAgencyCard.tsx" /></div><div><div className="font-medium">E-Leilões</div></div></div>{realEstate.businessType === BusinessType.Auction && <AuctionPriceTable className="gap-1" salePrice={realEstate.salePrice ?? ""} lastBidPrice={realEstate.lastBidPrice ?? ""} minPrice={realEstate.minPrice ?? ""} openingPrice={realEstate.openingPrice ?? ""} />}{features?.find(_temp3)?.featureValue && <div className="text-foreground-heading w-full rounded-md py-1.5 text-sm font-medium flex items-center"><Clock className="h-4 w-4 mr-1.5" /><AuctionTimer showSeconds={true} auctionFinishTime={features.find(_temp4)?.featureValue} /></div>}</div><Link onClick={_temp5} target="_blank" href={realEstate.propertyUrl} data-sentry-element="Link" data-sentry-source-file="RealEstateAgencyCard.tsx"><Button variant="simpleDark" className="w-full" data-sentry-element="Button" data-sentry-source-file="RealEstateAgencyCard.tsx">{t("visitProperty")}</Button></Link></CardContent>;
    $[16] = features;
    $[17] = realEstate.businessType;
    $[18] = realEstate.lastBidPrice;
    $[19] = realEstate.logoSquared;
    $[20] = realEstate.minPrice;
    $[21] = realEstate.openingPrice;
    $[22] = realEstate.propertyUrl;
    $[23] = realEstate.salePrice;
    $[24] = t;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  const renderAuctionContent = t3;
  switch (realEstate.businessType) {
    case BusinessType.Sale:
    case BusinessType.Rent:
      {
        let t4;
        if ($[26] !== isMobile || $[27] !== renderSaleContent) {
          t4 = isMobile ? renderSaleContent() : <Card className="bg-card">{renderSaleContent()}</Card>;
          $[26] = isMobile;
          $[27] = renderSaleContent;
          $[28] = t4;
        } else {
          t4 = $[28];
        }
        return t4;
      }
    case BusinessType.Auction:
      {
        let t4;
        if ($[29] !== renderAuctionContent) {
          t4 = <Card className="bg-card">{renderAuctionContent()}</Card>;
          $[29] = renderAuctionContent;
          $[30] = t4;
        } else {
          t4 = $[30];
        }
        return t4;
      }
    case BusinessType.RoomRent:
      {
        let t4;
        if ($[31] !== agency || $[32] !== handleCopy || $[33] !== handleSendMessage || $[34] !== hasContacts || $[35] !== isMobile || $[36] !== isOwner || $[37] !== phones || $[38] !== realEstate.propertyUrl || $[39] !== realEstate.reference || $[40] !== title || $[41] !== url || $[42] !== user) {
          t4 = <RealEstateAgencyCardRoomRent user={user} hasContacts={hasContacts} phones={phones} title={title} url={url} reference={realEstate.reference} referenceUrl={realEstate.propertyUrl} handleCopy={handleCopy} agency={agency} isOwner={isOwner} handleSendMessage={handleSendMessage} hideMessageButton={isMobile} />;
          $[31] = agency;
          $[32] = handleCopy;
          $[33] = handleSendMessage;
          $[34] = hasContacts;
          $[35] = isMobile;
          $[36] = isOwner;
          $[37] = phones;
          $[38] = realEstate.propertyUrl;
          $[39] = realEstate.reference;
          $[40] = title;
          $[41] = url;
          $[42] = user;
          $[43] = t4;
        } else {
          t4 = $[43];
        }
        return t4;
      }
    default:
      {
        return null;
      }
  }
}
function _temp5(e) {
  return e.stopPropagation();
}
function _temp4(feature) {
  return feature.featureKey === "auction_finish_time";
}
function _temp3(feature_0) {
  return feature_0.featureKey === "auction_finish_time";
}
function _temp2(agent_0) {
  return <CardAvatar key={agent_0.id} imgUrl={agent_0.photo || ""} name={agent_0.name} className="h-12 w-12 border-2 border-card shadow-md" />;
}
function _temp(agent) {
  return agent?.name;
}